// extracted by mini-css-extract-plugin
module.exports =  {"policyDocumentContainer":"PolicyCommonDocuments_policyDocumentContainer__1kiN7"};